import { useCallback, useEffect } from 'react';

export const useDisableScroll = () => {
  const disableScroll = useCallback(() => {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollBarWidth}px`;
  }, []);

  const enableScroll = useCallback(() => {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }, []);

  useEffect(() => {
    // Cleanup on unmount or route change
    return () => {
      enableScroll();
    };
  }, [enableScroll]);

  return { disableScroll, enableScroll };
};
